import { useContext } from 'react';
import {
  UserContext,
  type UserContextValue,
} from '../contexts/UserContextDefinition';

export function useUser(): UserContextValue {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}

export function useUserId(): string | null {
  const { user } = useUser();
  return user?.userId || null;
}

export function useUserRole(): string | null {
  const { user } = useUser();
  return user?.roleId || null;
}

export function useUserTenant(): string | null {
  const { user } = useUser();
  return user?.targetTenant || null;
}
